import { render, staticRenderFns } from "./selectTJTC.vue?vue&type=template&id=bb6a7ab0"
import script from "./selectTJTC.vue?vue&type=script&lang=js"
export * from "./selectTJTC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports